import { useState } from "react";

import useVehiclesMutations from "../../../data/useVehiclesMutations";
import useDefaultCRUDHandlers from "../../../hooks/useDefaultCRUDHandlers";
import { IVehicle } from "../../../models/Vehicle";
import Card from "../../shared/Card/Card";

export default function VehicleNotes({ vehicle, hideCard = false }: { vehicle: IVehicle, hideCard?: boolean }) {
  const { updateNotes } = useVehiclesMutations();
  const { saveHandlers } = useDefaultCRUDHandlers("Vehicle Notes");
  const [vehicleNotes, setVehicleNotes] = useState(vehicle?.notes);

  const handleSaveVehicleNotes = () => {
    //Don't update if nothing changed
    if (vehicleNotes === vehicle?.notes) return;

    const updateData = {
      vehicleId: vehicle.id,
      notes: vehicleNotes ?? null,
    };

    updateNotes.mutate(updateData, saveHandlers);
  }

  const body = (
    <div className="space-y-4">

      <textarea
        className="w-full border-gray-300"
        rows={5}
        defaultValue={vehicle?.notes!}
        onChange={(e) => setVehicleNotes(e.target.value)}
        onBlur={() => handleSaveVehicleNotes()}
      />

      <button
        className="rounded-md border border-transparent bg-primary-600 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-primary-700"
        onClick={() => handleSaveVehicleNotes()}
      >
        Update
      </button>

    </div>
  );

  if (hideCard) {
    return <div className="p-4">{body}</div>;
  }

  return (
    <Card title="Vehicle Notes" bodyClassName="p-4">
      {body}
    </Card>
  );
}
